module.exports = __webpack_public_path__ + "static/media/Line_Light.029109de.svg";